import { MapLegend } from './MapLegend';
import type { MeanPriceStop } from '../utils/mapScales';

const formatDollars = (price: number): string =>
  `$${price.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;

export function MeanPriceLegend({ stops, perSqft = false }: { stops: MeanPriceStop[]; perSqft?: boolean }) {
  if (stops.length < 2) {
    return null;
  }
  return (
    <MapLegend
      title={perSqft ? 'Mean price per sq ft' : 'Mean sale price'}
      colors={stops.map((stop) => stop.color)}
      labels={[...stops].reverse().map((stop) => formatDollars(stop.price))}
    />
  );
}
